import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MediaBluetoothOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"media_bluetooth_on"}/>
}
